// React
import React, { useEffect } from "react";
import { useHistory } from "react-router";
// Utils
import { CREATE_FIELD } from "constants/Routes";
import { ELEMENTS_IDS } from "constants/ElementsIds";
import { useEventRequest, useLivestockTabs } from "hooks";
// Components
import { FieldItem } from "components/MyLivestock";
import {
  LoadingOverlay,
  NoItemsFound,
  Header,
  PageContent,
  PageHeader,
  Spacer,
  Tabs,
  Tiles,
  EmptyState,
} from "components";
import { useFieldsQuery } from "generated/graphql";
import { removeNothings } from "helpers/general/all";
import { getBUFromLocalStorage } from "helpers/storage";
// Resources
import styles from "./Fields.module.scss";

const Fields: React.FC = () => {
  const history = useHistory();
  const { eventsRequest } = useEventRequest();
  const LIVESTOCK_TABS = useLivestockTabs();
  const { data: fieldsData, loading } = useFieldsQuery({
    variables: {
      businessUnitId: getBUFromLocalStorage(),
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  const fields = removeNothings(fieldsData?.fields || []);

  const isEmptyStateVisible = !loading && !fields.length;

  useEffect(() => {
    eventsRequest({ name: "field-show" });
  }, [eventsRequest]);

  return (
    <>
      <PageHeader>
        <Header title="My Livestock" subTitle="View and manage your livestock" />

        <Tabs tabs={LIVESTOCK_TABS} selectedTab={2} />
      </PageHeader>

      <PageContent
        floatingIconButton={{
          id: ELEMENTS_IDS.ADD_FIELD_PLUS_BUTTON,
          iconName: "plus",
          onClick: (): void => history.push(CREATE_FIELD),
        }}
      >
        {loading && fields?.length === 0 && <LoadingOverlay customStyles={styles.loadingOverlay} />}

        <Spacer baselineHeight={2} />

        {isEmptyStateVisible ? (
          <EmptyState page="FIELDS" />
        ) : (
          <>
            <Tiles size="large">
              {fields.map((field) => (
                <FieldItem field={field} key={`field_${field.id}`} history={history} />
              ))}
            </Tiles>

            {!loading && fields.length === 0 && <NoItemsFound title="No fields found" />}
          </>
        )}
      </PageContent>
    </>
  );
};

export default Fields;
